import { useState } from "react"
import useCloseRequest from "../hooks/useCloseRequest"
import "./LanguageSheet.css"

// Mirrors the Profile language bottom sheet: one radio per catalogue row in the
// order the API returned, labelled native_name, then Save Details and Go Back.
export default function LanguageSheet({ languages, current, onSave, onClose }) {
  const [pending, setPending] = useState(current)
  useCloseRequest(true, onClose)

  return (
    <div className="lang" role="dialog" aria-modal="true" aria-label="Language">
      <button type="button" className="lang__scrim" aria-label="Close" onClick={onClose} />

      <div className="lang__sheet">
        <span className="lang__grabber" aria-hidden="true" />
        <h2 className="lang__title t-y24">Language</h2>
        <span className="lang__rule" />

        <ul className="lang__options" role="radiogroup">
          {languages.map((language, index) => (
            <li key={language.code}>
              <button
                type="button"
                className="lang__option"
                role="radio"
                aria-checked={pending === language.code}
                onClick={() => setPending(language.code)}
              >
                <span className="lang__option-text t-p16" lang={language.code}>
                  {language.native_name}
                </span>
                <img
                  className="lang__radio"
                  src={pending === language.code ? "/img/radio-on.png" : "/img/radio-off.png"}
                  alt=""
                  aria-hidden="true"
                />
              </button>
              {index < languages.length - 1 && <span className="lang__divider" />}
            </li>
          ))}
        </ul>

        <div className="lang__actions">
          <button type="button" className="lang__save" onClick={() => onSave(pending)}>
            Save Details
          </button>
          <button type="button" className="lang__cancel" onClick={onClose}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  )
}
